import { create } from "zustand";
import { persist } from "zustand/middleware";

interface UiPrefsState {
  summaryActiveSections: Record<string, string[]>;
  setSummaryActiveSections: (pathname: string, keys: string[]) => void;
  reset: () => void;
}

const STORAGE_KEY = "xm-ui-prefs";

const initialState: Pick<UiPrefsState, "summaryActiveSections"> = {
  summaryActiveSections: {},
};

export const useUiPrefsStore = create<UiPrefsState>()(
  persist(
    (set) => ({
      ...initialState,
      setSummaryActiveSections: (pathname, keys) =>
        set((state) => ({
          summaryActiveSections: { ...state.summaryActiveSections, [pathname]: keys },
        })),
      reset: () => {
        set(initialState);
        void useUiPrefsStore.persist.clearStorage();
      },
    }),
    { name: STORAGE_KEY, version: 1 }
  )
);

if (globalThis.window !== undefined) {
  globalThis.window.addEventListener("storage", (e) => {
    if (e.key === STORAGE_KEY) {
      void useUiPrefsStore.persist.rehydrate();
    }
  });
}

